import { render } from "./ApprovalFlowConfigManagement.vue?vue&type=template&id=40cd07b8&scoped=true"
import script from "./ApprovalFlowConfigManagement.vue?vue&type=script&lang=js"
export * from "./ApprovalFlowConfigManagement.vue?vue&type=script&lang=js"

import "./ApprovalFlowConfigManagement.vue?vue&type=style&index=0&id=40cd07b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cd07b8"]])

export default __exports__